export const PRODUCT_CATEGORIES = [
  "Accesorios de vestir",
  "Accesorios para mascotas",  
  "Alimentos para mascotas",
  "Artículos de limpieza",
  "Bebidas",
  "Belleza y cosmética",
  "Carnicería y pescadería",
  "Complementos móviles y lifestyle",
  "Congelados",
  "Cuidado de bebés",
  "Detergentes y limpiadores",
  "Electrodomésticos",
  "Escolar y oficina",
  "Eventos especiales",
  "Ferretería general",
  "Festividades",
  "Frutas y verduras",
  "Granos, conservas, aceites",
  "Higiene personal",
  "Lácteos y huevos",
  "Medicamentos",
  "Menaje y vajilla",
  "Panadería",
  "Papeles y bolsas",
  "Pilas y cables",
  "Productos basicos",
  "Reposteria y Dulces",
  "Ropa para hombre",
  "Ropa para mujer",
  "Ropa para niños",
  "Tarjetas y periódicos",
  "Zapatos",
] as const;

export type ProductCategory = (typeof PRODUCT_CATEGORIES)[number];
